export const language = {
  it_IT: {
    sfoglia: "Sfoglia",
    svuota_carrello: "Svuota carrello",
    cancella_lista: "Cancella la lista",
    manuale: "Istruzioni",
    scheda: "Scheda",
    allegato: "Allegato",
    volantino: "Sfoglia",
    prodotti: "Prodotti",
    pagine: "Pagine",
    pdf: "PDF",
    catalogo: "Catalogo",
    schermo_intero: "Schermo Intero",
    condividi_volantino: "Condividi Pubblicazione",
    punti_vendita: "Punti vendita",
    prodotto: "Prodotto",
    scegli_una_categoria: "Scegli una categoria",
    scegli_una_sottocategoria: "Scegli una sottocategoria",
    reset: "Reset",
    aggiungi_alla_lista: "Aggiungi",
    aggiungi_alla_lista_crai: "Aggiungi alla lista",
    aggiungi_al_carrello: "Aggiungi al carrello",
    aggiungi: "Aggiungi",
    aggiungi_crai: "Aggiungi alla lista",
    mostra_altri_prodotti: "Mostra altri prodotti",
    nessun_prodotto_trovato_per_i_parametri_di_ricerca_inseriti:
      "Nessun Prodotto trovato per i parametri di ricerca inseriti",
    effettua_ricerca:
      "Effettua una ricerca per visualizzare i prodotti in catalogo",
    dettaglio: "Dettaglio",
    indietro: "Indietro",
    chiudi: "Chiudi",
    scegli: "Scegli",
    prodotto_aggiunto: "Prodotto Aggiunto",
    controlla_la_tua_lista_della_spesa: "Controlla la tua lista della spesa",
    lista_della_spesa: "Lista della spesa",
    la_tua_lista_della_spesa: "La tua lista della spesa",
    elimina_dalla_lista: "Elimina dalla lista",
    elimina_dal_carrello: "Elimina dal carrello",
    condividi_lista: "Condividi",
    condividi_con: "Condividi con",
    totale: "Totale",
    imponibile: "Imponibile",
    iva: "IVA",
    iva_inclusa: "IVA Inclusa",
    svuota: "Svuota",
    inserisci_un_prodotto_non_presente: "Inserisci un prodotto non presente",
    nome_prodotto: "Nome prodotto",
    prezzo_stimato: "Prezzo stimato",
    cerca_un_prodotto: "Cerca prodotto",
    link_copiato_negli_appunti: "Link Copiato Negli appunti",
    curiosita: "Curiosità",
    video: "Video",
    ricetta: "Ricetta",
    ingredienti: "Ingredienti",
    procedimento: "Procedimento",
    indice: "Indice",
    menu: "Menù",
    video_tutorial: "Video Tutorial",
    condividi: "Condividi",
    filtra_prodotti: "Filtra prodotti",
    filtra: "Filtra",
    mostra: "Mostra",
    risultati: "risultati",
    sto_caricando: "Sto caricando",
    secondi: "secondi",
    sfoglia_volantino_tra: "Sfoglia pubblicazione tra",
    reset_filtri: "Reset filtri",
    descrizione: "Descrizione",
    carosello: "Carosello",
    per_quantita: "per quantità",
    offerta: "Offerta",
    scopri_il_prezzo: "Scopri il prezzo",
    scopri: "Scopri",
    attendi_scopri_prezzo: "Attendi qualche istante per scoprire il prezzo di",
    caratteristiche: "Caratteristiche",
    il_tuo_carrello: "Il tuo carrello",
    stiamo_generando_lista_spesa: "Stiamo generando la tua lista della spesa",
    visualizza_lista_spesa: "Visualizza la tua lista della spesa",
    elemento_copiato: "Elemento copiato",
    errore_nella_copia: "Errore nella copia",
    link_non_copiato: "Link non copiato",
    torna_al_volantino: "Torna alla pubblicazione",
    salva_come_immagine: "Salva come immagine",
    sei_sicuro_svuota_carrello: "Sei sicuro di voler svuotare il tuo carrello",
    annulla: "Annulla",
    conferma: "Conferma",
    vai_prodotti: "Vai a prodotti",
    cerca: "Cerca",
    effettua_login: "Effettua il login",
    accedi_dall_app: "Accedi dall'app",
    accedi_dall_app_testo: "Per vedere il volantino accedi con il tuo account nell'app.",
    crea_account: "Crea un account",
    resetta_psw: "Resetta password",
    login: "Accedi",
    registrati: "Registrati",
    rec_psw: "Recupera",
    telephone: "Telefono",
    indirizzo: "Indirizzo",
    nome: "Nome",
    cognome: "Cognome",
    benvenuto: "Benvenuto",
    aggiungi_non_presente: "Ricorda di prendere anche",
    email: "Email",
    no_account: "Non hai un account? Registrati ",
    already_account: "Hai già un account? Accedi",
    email_non_presente: "Email non presente",
    mostra_piu: "Mostra di più",
    codice_cliente: "Codice cliente",
    password: "Password",
    completa_ordine: "Completa ordine",
    send_ordine: "Invia ordine",
    registrazione_success:
      "Registrazione effettuata con successo. Verifica la tua mail per poter accedere! Se nella casella In Entrata non trovi alcuna e-mail, verifica la tua casella SPAM",
    iva_esclusa: "IVA Esclusa",
    esporta_pdf: "Esporta pdf",
    esporta_csv: "Esporta CSV",
    parametri_mancanti: "Parametri mancanti",
    email_pass_non_trovati: "Email e/o password non trovati",
    email_presente: "Email già presente",
    token_non_valido: "Token non valido o già utilizzato",
    errore_registrazione: "Si è verificato un errore durante la registrazione",
    email_successo: "Email inviata con successo",
    errore_invio_mail: "Si è verificato un errore durante l'invio della mail",
    cookieText:
      "Utilizziamo i cookie per personalizzare contenuti ed annunci, per fornire funzionalità dei social media e per analizzare il nostro traffico. Condividiamo inoltre informazioni sul modo in cui utilizza il nostro sito con i nostri partner che si occupano di analisi dei dati web, pubblicità e social media, i quali potrebbero combinarle con altre informazioni che ha fornito loro o che hanno raccolto dal suo utilizzo dei loro servizi.",
    useCookie: "Questo sito web utilizza i cookie",
    necessari: "necessari",
    tecnici: "necessari",
    statistiche: "statistiche",
    consenso: "Consenso",
    accetta_tutti: "Accetta tutti",
    accetta_selezionati: "Accetta selezionati",
    rifiuta: "Rifiuta",
    cookie_detail_tech:
      "I cookie necessari contribuiscono a rendere fruibile il sito web abilitandone funzionalità di base quali la navigazione sulle pagine e l'accesso alle aree protette del sito. Il sito web non è in grado di funzionare correttamente senza questi cookie.",
    cookie_detail_stats:
      "I cookie statistici aiutano i proprietari del sito web a capire come i visitatori interagiscono con i siti raccogliendo e trasmettendo informazioni in forma anonima.",
    pec: "pec",
    sdi: "sdi",
    comune: "comune",
    provincia: "provincia",
    cap: "cap",
    phone: "telefono",
    ragione_sociale: "ragione sociale",
    partita_iva: "partita iva",
    username: "username",
    address: "indirizzo",
    extra1: "Nome del locale",
    lista: "Lista",
    cerca_uno_store: "Cerca uno store",
    mostra_tutti: "mostra tutti",
    cancella_filtri: "cancella filtri",
    pag: "pag",
    vai: "vai",
    apri: "Apri",
    prodotti_correlati: "Prodotti correlati",
    copia_link_lista: "Copia link lista",
    copia_link_volantino: "Copia link pubblicazione",
    copia: "Copia",
    carrello: "Carrello",
    benvenuto_lista_gia_inviata: "Bentornato!",
    benvenuto_lista_gia_inviata_messaggio: "Nella lista sono presenti dei prodotti. Vuoi lasciarli li o preferisci svuotarla?",
    svuota_lista: "Svuota lista",
    continua: "Continua",
    tutti: "Tutti",
    sottocategorie: "Sottocategorie",
    caricamento: "Caricamento…",
    hai_visto_tutto: "Hai visto tutto",
    mostra_tutti_reset: "Mostra tutti i prodotti",
    nessun_prodotto_hint: "Prova a selezionare un'altra categoria.",
    apri_filtri: "Apri filtri",
    rimuovi_filtro: "Rimuovi filtro {label}",
    offerte: "Offerte",
    interattivita_section: "Interattività",
    link_interno: "Link interno",
    link_esterno: "Link esterno",
    specifiche: "Specifiche",
    categorie: "Categorie",
    tutti_i_prodotti: "Tutti i prodotti",
    prodotti_filtrati: "Prodotti filtrati",
    risultati_per: "Risultati per «{q}»",
    filtri: "Filtri",
    nessun_filtro_selezionato: "Nessun filtro selezionato",
    n_filtri_selezionati: "{n} filtri selezionati",
    cancella: "Cancella",
    applica_filtri: "Applica filtri ({n})",
    nessun_risultato: "Nessun risultato",
    nessun_prodotto_combinazione:
      "Nessun prodotto con questa combinazione di filtri",
    tag_section: "Tag",
    promo_section: "Promo",
    marchi_section: "Marchi",
    chiudi_filtri: "Chiudi filtri",
    nessun_filtro_disponibile: "Nessun filtro disponibile per questa pubblicazione.",
    chiudi_ricerca: "Chiudi ricerca",
    cerca_prodotti: "Cerca prodotti",
    digita_almeno_2: "Digita almeno 2 caratteri",
    n_risultati_trovati: "{n} risultati trovati",
    n_risultati_primi_30: "{n} risultati · primi 30",
    nessun_risultato_per: "Nessun risultato per «{q}»",
    prova_altro_termine: "Prova con un altro termine o controlla l'ortografia",
    pulisci_ricerca: "Pulisci ricerca",
    inizia_a_digitare:
      "Inizia a digitare per cercare un prodotto del volantino attivo",
    categorie_suggerite: "Categorie suggerite",
    vedi_tutti_n_risultati: "Vedi tutti i {n} risultati nella lista",
    nessun_risultato_short: "Nessun risultato",
    // Auth & Profile
    password_dimenticata: "Password dimenticata?",
    invia_link_reset: "Invia link di reset",
    inserisci_email_reset: "Inserisci la tua email per recuperare la password",
    email_inviata_reset: "Ti abbiamo inviato un'email con il link per reimpostare la password",
    torna_al_login: "Torna al login",
    conferma_password: "Conferma password",
    accetto_privacy: "Accetto la privacy policy",
    password_non_corrispondono: "Le password non corrispondono",
    privacy_obbligatoria: "Devi accettare la privacy policy",
    password_min_length: "Almeno 8 caratteri",
    password_uppercase: "Una lettera maiuscola",
    password_lowercase: "Una lettera minuscola",
    password_number: "Un numero",
    password_special_char: "Un carattere speciale",
    profilo: "Profilo",
    modifica_profilo: "Modifica profilo",
    cambia_password: "Cambia password",
    elimina_account: "Elimina account",
    logout: "Logout",
    conferma_eliminazione: "Sei sicuro di voler eliminare il tuo account? Questa azione è irreversibile.",
    nuova_password: "Nuova password",
    conferma_nuova_password: "Conferma nuova password",
    salva_modifiche: "Salva modifiche",
    vai_al_profilo: "Vai al profilo",
    ordini: "Ordini",
    preferiti: "Preferiti",
    premi: "Premi",
    assistenza: "Assistenza",
    password_cambiata_successo: "Password cambiata con successo",
    profilo_aggiornato_successo: "Profilo aggiornato con successo",
    account_eliminato_successo: "Account eliminato con successo",
  },
  en_EN: {
    copia_link_volantino: "Copy publication link",
    copia: "Copy",
    carrello: "Cart",
    copia_link_lista: "Copy list link",
    apri: "Open",
    vai: "go",
    prodotti_correlati: "Correlated products",
    pag: "page",
    cancella_filtri: "delete filters",
    mostra_tutti: "show all",
    cerca_uno_store: "Search a store",
    lista: "List",
    sfoglia: "Browse",
    extra1: "Name of the venue",
    send_ordine: "Send order",
    username: "username",
    cookie_detail_tech:
      "Necessary cookies help make the website usable by enabling basic functionality such as page navigation and access to protected areas of the website. The website cannot function properly without these cookies.",
    cookie_detail_stats:
      "Statistical cookies help website owners understand how visitors interact with the sites by collecting and transmitting information anonymously.",
    rifiuta: "Reject",
    accetta_selezionati: "Accept selected",
    consenso: "Consent",
    necessari: "required",
    tecnici: "required",
    statistiche: "stats",
    useCookie: "This website uses cookies",
    cookieText:
      "We use cookies to personalize content and ads, to provide social media features, and to analyze our traffic. We also share information about how you use our site with our partners who are involved in web analytics web data, advertising and social media, who may combine it with other information that you have provided to them or that they have collected from your use of their services.",
    errore_invio_mail: "Error while sending the email",
    email_successo: "Email sent successfully",
    errore_registrazione: "An error occurred during registration",
    token_non_valido: "Invalid or already used token",
    email_presente: "Email already in use",
    svuota_carrello: "Empty cart",
    cancella_lista: "Delete list",
    manuale: "Instructions",
    scheda: "Card",
    filtra: "Filter",
    allegato: "Attachment",
    volantino: "Browse",
    prodotti: "Products",
    punti_vendita: "Point of sale",
    catalogo: "Catalogue",
    pagine: "Pages",
    pdf: "PDF",
    schermo_intero: "Fullscreen",
    condividi_volantino: "Share Publication",
    prodotto: "Product",
    scegli_una_categoria: "Choose a category",
    scegli_una_sottocategoria: "Choose a subcategory",
    reset: "Reset",
    aggiungi_alla_lista: "Add to list",
    aggiungi_alla_lista_crai: "Add to list",
    aggiungi_al_carrello: "Add to cart",
    aggiungi: "Aggiungi",
    aggiungi_crai: "Add to list",
    mostra_altri_prodotti: "Show more products",
    nessun_prodotto_trovato_per_i_parametri_di_ricerca_inseriti:
      "No Product found for search parameters",
    effettua_ricerca: "Do a search to view products in the catalog",
    dettaglio: "Detail",
    indietro: "Back",
    chiudi: "Close",
    scegli: "Choose",
    prodotto_aggiunto: "Product Added",
    controlla_la_tua_lista_della_spesa: "Check your shopping list",
    lista_della_spesa: "Shopping list",
    la_tua_lista_della_spesa: "Your shopping list",
    elimina_dalla_lista: "Delete from list",
    elimina_dal_carrello: "Remove from cart",
    condividi_lista: "Share",
    condividi_con: "Share with",
    totale: "Total",
    imponibile: "Net amount",
    iva: "VAT",
    iva_inclusa: "VAT included",
    svuota: "Clear",
    inserisci_un_prodotto_non_presente: "Enter a non-existing product",
    nome_prodotto: "Product Name",
    prezzo_stimato: "Estimated Price",
    cerca_un_prodotto: "Search a Product",
    link_copiato_negli_appunti: "Link Copied To the clipboard",
    curiosita: "Curiosity",
    video: "Video",
    ricetta: "Recipe",
    ingredienti: "Ingredients",
    procedimento: "Proceedings",
    indice: "Index",
    menu: "Menù",
    video_tutorial: "Video Tutorial",
    condividi: "Share",
    filtra_prodotti: "Filter products",
    mostra: "Show",
    risultati: "results",
    sto_caricando: "loading",
    secondi: "seconds",
    sfoglia_volantino_tra: "Browse the publication in",
    reset_filtri: "Reset filters",
    descrizione: "Description",
    carosello: "Carousel",
    per_quantita: "for quantity",
    offerta: "Offer",
    scopri_il_prezzo: "Show price",
    scopri: "Show",
    attendi_scopri_prezzo: "Wait a few moments to see the price of",
    caratteristiche: "Specs",
    il_tuo_carrello: "Your Shopping Cart",
    stiamo_generando_lista_spesa: "Generating your shopping list",
    visualizza_lista_spesa: "Show your shopping list",
    elemento_copiato: "Item copied",
    errore_nella_copia: "Copy error",
    link_non_copiato: "Link not copied",
    torna_al_volantino: "Back to publication",
    salva_come_immagine: "Save as image",
    sei_sicuro_svuota_carrello: "Are you sure to clear your cart",
    annulla: "Cancel",
    conferma: "Confirm",
    vai_prodotti: "Go to products",
    cerca: "Search",
    effettua_login: "Please login",
    accedi_dall_app: "Log in from the app",
    accedi_dall_app_testo: "Log in with your account in the app to view the flyer.",
    crea_account: "Create account",
    resetta_psw: "Reset password",
    login: "Login",
    registrati: "Register",
    rec_psw: "Recover",
    telephone: "Telephone",
    indirizzo: "Address",
    nome: "Name",
    cognome: "Surname",
    benvenuto: "Welcome",
    aggiungi_non_presente: "Add a product not present",
    email: "Email",
    no_account: "Don't have an account? Register ",
    already_account: "Do you already have an account? Sign in.",
    email_non_presente: "Email not present",
    mostra_piu: "Show more",
    codice_cliente: "Customer code",
    password: "Password",
    completa_ordine: "Complete order",
    registrazione_success:
      "Registration successful. Please check your email to access! If you don't find any emails in your Inbox, check your SPAM box.",
    iva_esclusa: "VAT excluded",
    esporta_pdf: "Export to PDF",
    esporta_csv: "Export to CSV",
    email_pass_non_trovati: "Email and/or password not found",
    parametri_mancanti: "Missing parameters",
    accetta_tutti: "Accept all",
    lista_gia_inviata: "Order already sent",
    lista_inviata_messaggio: "This order has already been sent. What would you like to do?",
    lista_inviata_messaggio_whatsapp: "This shopping list has already been sent via WhatsApp. What would you like to do?",
    svuota_lista: "Clear list",
    continua: "Continue",
    benvenuto_lista_gia_inviata: "Welcome back!",
    benvenuto_lista_gia_inviata_messaggio: "There are products in the list. Do you want to keep them or clear the list?",
    tutti: "All",
    sottocategorie: "Subcategories",
    caricamento: "Loading…",
    hai_visto_tutto: "You've seen it all",
    mostra_tutti_reset: "Show all products",
    nessun_prodotto_hint: "Try another category.",
    apri_filtri: "Open filters",
    rimuovi_filtro: "Remove filter {label}",
    offerte: "Deals",
    interattivita_section: "Interactivities",
    link_interno: "Internal link",
    link_esterno: "External link",
    specifiche: "Specs",
    categorie: "Categories",
    tutti_i_prodotti: "All products",
    prodotti_filtrati: "Filtered products",
    risultati_per: "Results for «{q}»",
    filtri: "Filters",
    nessun_filtro_selezionato: "No filter selected",
    n_filtri_selezionati: "{n} filters selected",
    cancella: "Clear",
    applica_filtri: "Apply filters ({n})",
    nessun_risultato: "No results",
    nessun_prodotto_combinazione:
      "No products match this filter combination",
    tag_section: "Tag",
    promo_section: "Promo",
    marchi_section: "Brands",
    chiudi_filtri: "Close filters",
    nessun_filtro_disponibile: "No filters available for this publication.",
    chiudi_ricerca: "Close search",
    cerca_prodotti: "Search products",
    digita_almeno_2: "Type at least 2 characters",
    n_risultati_trovati: "{n} results found",
    n_risultati_primi_30: "{n} results · top 30",
    nessun_risultato_per: "No results for «{q}»",
    prova_altro_termine: "Try a different term or check spelling",
    pulisci_ricerca: "Clear search",
    inizia_a_digitare: "Start typing to search a product in the active flyer",
    categorie_suggerite: "Suggested categories",
    vedi_tutti_n_risultati: "See all {n} results in the list",
    nessun_risultato_short: "No results",
    // Auth & Profile
    password_dimenticata: "Forgot password?",
    invia_link_reset: "Send reset link",
    inserisci_email_reset: "Enter your email to recover your password",
    email_inviata_reset: "We sent you an email with a link to reset your password",
    torna_al_login: "Back to login",
    conferma_password: "Confirm password",
    accetto_privacy: "I accept the privacy policy",
    password_non_corrispondono: "Passwords do not match",
    privacy_obbligatoria: "You must accept the privacy policy",
    password_min_length: "At least 8 characters",
    password_uppercase: "One uppercase letter",
    password_lowercase: "One lowercase letter",
    password_number: "One number",
    password_special_char: "One special character",
    profilo: "Profile",
    modifica_profilo: "Edit profile",
    cambia_password: "Change password",
    elimina_account: "Delete account",
    logout: "Logout",
    conferma_eliminazione: "Are you sure you want to delete your account? This action is irreversible.",
    nuova_password: "New password",
    conferma_nuova_password: "Confirm new password",
    salva_modifiche: "Save changes",
    vai_al_profilo: "Go to profile",
    ordini: "Orders",
    preferiti: "Favorites",
    premi: "Prizes",
    assistenza: "Support",
    password_cambiata_successo: "Password changed successfully",
    profilo_aggiornato_successo: "Profile updated successfully",
    account_eliminato_successo: "Account deleted successfully",
  },
  fr_FR: {
    carrello: "Chariot",
    copia_link_volantino: "Copie le lien de la publication",
    copia: "Copier",
    copia_link_lista: "Copier le lien de la liste",
    apri: "Ouvert",
    lista: "Liste",
    cerca_uno_store: "Trouver un magasin",
    mostra_tutti: "tout afficher",
    cancella_filtri: "supprimer les filtres",
    pag: "page",
    vai: "aller",
    prodotti_correlati: "Produits associés",
    sfoglia: "Consulter",
    extra1: "Nom du lieu",
    send_ordine: "Envoyer l'ordre",
    username: "Nom d'utilisateur",
    cookie_detail_tech:
      "Les cookies nécessaires contribuent à la convivialité du site web en permettant des fonctionnalités de base telles que la navigation sur les pages et l'accès aux zones sécurisées du site web. Le site web ne peut pas fonctionner correctement sans ces cookies.",
    cookie_detail_stats:
      "Les cookies statistiques aident les propriétaires de sites web à comprendre comment les visiteurs interagissent avec les sites en collectant et en transmettant des informations sous une forme anonyme.",
    rifiuta: "Rejeter",
    accetta_selezionati: "Accepter la sélection",
    accetta_tutti: "Accepter tous",
    consenso: "Consentement",
    necessari: "nécessaire",
    tecnici: "nécessaire",
    statistiche: "statistiques",
    useCookie: "Ce site web utilise des cookies",
    cookieText:
      "Nous utilisons des cookies pour personnaliser le contenu et les publicités, pour fournir des fonctions de médias sociaux et pour analyser notre trafic. Nous partageons également des informations sur la façon dont vous utilisez notre site avec nos partenaires d'analyse web, de publicité et de médias sociaux, qui peuvent les combiner avec d'autres informations que vous leur avez fournies ou qu'ils ont collectées à partir de votre utilisation de leurs services.",
    errore_invio_mail: "Erreur lors de l'envoi du courrier électronique",
    email_successo: "Courriel envoyé avec succès",
    errore_registrazione: "Une erreur s'est produite lors de l'enregistrement",
    token_non_valido: "Jeton non valide ou déjà utilisé",
    email_presente: "Email déjà utilisée",
    svuota_carrello: "Vider le panier",
    cancella_lista: "Effacer la liste",
    manuale: "Manuel",
    scheda: "Carte",
    allegato: "Pièce jointe",
    volantino: "Parcourir",
    prodotti: "Produits",
    catalogo: "Catalogue",
    pagine: "Pages",
    pdf: "PDF",
    schermo_intero: "Plein écran",
    condividi_volantino: "Partager le publication",
    prodotto: "Produit",
    scegli_una_categoria: "Choisissez une catégorie",
    scegli_una_sottocategoria: "Choisissez une sous-catégorie",
    reset: "Réinitialiser",
    aggiungi_alla_lista: "Ajouter à la liste",
    aggiungi_alla_lista_crai: "Ajouter à la liste",
    aggiungi_al_carrello: "Ajouter au panier",
    aggiungi: "Ajouter",
    aggiungi_crai: "Ajouter à la liste",
    mostra_altri_prodotti: "Afficher plus de produits",
    nessun_prodotto_trovato_per_i_parametri_di_ricerca_inseriti:
      "Aucun produit trouvé pour les paramètres de recherche saisis",
    effettua_ricerca:
      "Effectuez une recherche pour afficher les produits du catalogue",
    dettaglio: "Détail",
    indietro: "Retour",
    chiudi: "Fermer",
    scegli: "Choisir",
    prodotto_aggiunto: "Produit ajouté",
    controlla_la_tua_lista_della_spesa: "Vérifiez votre liste de courses",
    lista_della_spesa: "Liste de courses",
    la_tua_lista_della_spesa: "Votre liste de courses",
    elimina_dalla_lista: "Supprimer de la liste",
    elimina_dal_carrello: "Supprimer du panier",
    condividi_lista: "Partager",
    condividi_con: "Partager avec",
    totale: "Total",
    imponibile: "Montant HT",
    iva: "TVA",
    iva_inclusa: "TVA incluse",
    svuota: "Vider",
    punti_vendita: "Points de vente",
    inserisci_un_prodotto_non_presente: "Saisissez un produit inexistant",
    nome_prodotto: "Nom du produit",
    prezzo_stimato: "Prix estimé",
    cerca_un_prodotto: "Rechercher un produit",
    link_copiato_negli_appunti: "Lien copié dans le presse-papiers",
    curiosita: "Curiosité",
    video: "Vidéo",
    ricetta: "Recette",
    ingredienti: "Ingrédients",
    procedimento: "Procédure",
    indice: "Index",
    menu: "Menu",
    video_tutorial: "Tutoriel vidéo",
    condividi: "Partager",
    filtra_prodotti: "Filtrer les produits",
    filtra: "Filtrer",
    mostra: "Afficher",
    risultati: "résultats",
    sto_caricando: "Chargement en cours",
    secondi: "secondes",
    sfoglia_volantino_tra: "Feuilleter le publication parmi",
    reset_filtri: "Réinitialiser les filtres",
    descrizione: "Description",
    carosello: "Carrousel",
    per_quantita: "par quantité",
    offerta: "Offre",
    scopri_il_prezzo: "Découvrir le prix",
    scopri: "Découvrir",
    attendi_scopri_prezzo:
      "Veuillez patienter quelques instants pour découvrir le prix de",
    caratteristiche: "Caractéristiques",
    il_tuo_carrello: "Votre panier",
    stiamo_generando_lista_spesa: "Nous générons votre liste de courses",
    visualizza_lista_spesa: "Afficher votre liste de courses",
    elemento_copiato: "Élément copié",
    errore_nella_copia: "Erreur de copie",
    link_non_copiato: "Lien non copié",
    torna_al_volantino: "Retour à la publication",
    salva_come_immagine: "Enregistrer en tant qu'image",
    sei_sicuro_svuota_carrello: "Êtes-vous sûr de vouloir vider votre panier",
    annulla: "Annuler",
    conferma: "Confirmer",
    vai_prodotti: "Aller aux produits",
    cerca: "Rechercher",
    effettua_login: "Veuillez vous connecter",
    accedi_dall_app: "Connectez-vous depuis l'app",
    accedi_dall_app_testo: "Connectez-vous avec votre compte dans l'app pour voir le dépliant.",
    crea_account: "Créer un compte",
    resetta_psw: "Réinitialiser le mot de passe",
    login: "Connexion",
    registrati: "S'inscrire",
    rec_psw: "Récupérer",
    telephone: "Téléphone",
    indirizzo: "Adresse",
    nome: "Nom",
    cognome: "Prénom",
    benvenuto: "Bienvenue",
    aggiungi_non_presente: "Ajouter un produit non présent",
    email: "Email",
    no_account: "Vous n'avez pas de compte ? Inscrivez-vous",
    already_account: "Vous avez déjà un compte ? Connectez-vous",
    email_non_presente: "L'email n'est pas présent",
    mostra_piu: "Afficher plus",
    codice_cliente: "Code client",
    password: "mot de passe",
    completa_ordine: "Finaliser la commande",
    registrazione_success:
      " Inscription réussie. Veuillez vérifier votre courrier électronique pour accéder! Si vous ne trouvez aucun e-mail dans votre boîte de réception, vérifiez votre boîte SPAM.",
    iva_esclusa: "Hors TVA",
    esporta_pdf: "Exporter en PDF",
    esporta_csv: "Exportar a CSV",
    parametri_mancanti: "Paramètres manquants",
    email_pass_non_trovati: "Email y/o contraseña no encontrados",
    lista_gia_inviata: "Commande déjà envoyée",
    lista_inviata_messaggio: "Cette commande a déjà été envoyée. Que souhaitez-vous faire?",
    lista_inviata_messaggio_whatsapp: "Cette liste de courses a déjà été envoyée via WhatsApp. Que souhaitez-vous faire?",
    svuota_lista: "Vider la liste",
    continua: "Continuer",
    benvenuto_lista_gia_inviata: "Bienvenue!",
    benvenuto_lista_gia_inviata_messaggio: "Il y a des produits dans la liste. Voulez-vous les garder ou vider la liste?",
    tutti: "Tous",
    sottocategorie: "Sous-catégories",
    caricamento: "Chargement…",
    hai_visto_tutto: "Vous avez tout vu",
    mostra_tutti_reset: "Afficher tous les produits",
    nessun_prodotto_hint: "Essayez une autre catégorie.",
    apri_filtri: "Ouvrir les filtres",
    rimuovi_filtro: "Supprimer filtre {label}",
    offerte: "Offres",
    interattivita_section: "Interactivités",
    link_interno: "Lien interne",
    link_esterno: "Lien externe",
    specifiche: "Spécifications",
    categorie: "Catégories",
    tutti_i_prodotti: "Tous les produits",
    prodotti_filtrati: "Produits filtrés",
    risultati_per: "Résultats pour «{q}»",
    filtri: "Filtres",
    nessun_filtro_selezionato: "Aucun filtre sélectionné",
    n_filtri_selezionati: "{n} filtres sélectionnés",
    cancella: "Effacer",
    applica_filtri: "Appliquer les filtres ({n})",
    nessun_risultato: "Aucun résultat",
    nessun_prodotto_combinazione:
      "Aucun produit ne correspond à cette combinaison de filtres",
    tag_section: "Tag",
    promo_section: "Promo",
    marchi_section: "Marques",
    chiudi_filtri: "Fermer les filtres",
    nessun_filtro_disponibile: "Aucun filtre disponible pour cette publication.",
    chiudi_ricerca: "Fermer la recherche",
    cerca_prodotti: "Rechercher des produits",
    digita_almeno_2: "Saisissez au moins 2 caractères",
    n_risultati_trovati: "{n} résultats trouvés",
    n_risultati_primi_30: "{n} résultats · 30 premiers",
    nessun_risultato_per: "Aucun résultat pour «{q}»",
    prova_altro_termine: "Essayez un autre terme ou vérifiez l'orthographe",
    pulisci_ricerca: "Effacer la recherche",
    inizia_a_digitare:
      "Commencez à saisir pour rechercher un produit du dépliant actif",
    categorie_suggerite: "Catégories suggérées",
    vedi_tutti_n_risultati: "Voir tous les {n} résultats dans la liste",
    nessun_risultato_short: "Aucun résultat",
    // Auth & Profile
    password_dimenticata: "Mot de passe oubli\u00e9 ?",
    invia_link_reset: "Envoyer le lien de r\u00e9initialisation",
    inserisci_email_reset: "Entrez votre email pour r\u00e9cup\u00e9rer votre mot de passe",
    email_inviata_reset: "Nous vous avons envoy\u00e9 un email avec un lien pour r\u00e9initialiser votre mot de passe",
    torna_al_login: "Retour \u00e0 la connexion",
    conferma_password: "Confirmer le mot de passe",
    accetto_privacy: "J'accepte la politique de confidentialit\u00e9",
    password_non_corrispondono: "Les mots de passe ne correspondent pas",
    privacy_obbligatoria: "Vous devez accepter la politique de confidentialit\u00e9",
    password_min_length: "Au moins 8 caract\u00e8res",
    password_uppercase: "Une lettre majuscule",
    password_lowercase: "Une lettre minuscule",
    password_number: "Un chiffre",
    password_special_char: "Un caract\u00e8re sp\u00e9cial",
    profilo: "Profil",
    modifica_profilo: "Modifier le profil",
    cambia_password: "Changer le mot de passe",
    elimina_account: "Supprimer le compte",
    logout: "Logout",
    conferma_eliminazione: "\u00cates-vous s\u00fbr de vouloir supprimer votre compte ? Cette action est irr\u00e9versible.",
    nuova_password: "Nouveau mot de passe",
    conferma_nuova_password: "Confirmer le nouveau mot de passe",
    salva_modifiche: "Enregistrer les modifications",
    vai_al_profilo: "Aller au profil",
    ordini: "Commandes",
    preferiti: "Favoris",
    premi: "Prix",
    assistenza: "Assistance",
    password_cambiata_successo: "Mot de passe chang\u00e9 avec succ\u00e8s",
    profilo_aggiornato_successo: "Profil mis \u00e0 jour avec succ\u00e8s",
    account_eliminato_successo: "Compte supprim\u00e9 avec succ\u00e8s",
  },
  de_DE: {
    carrello: "Wagen",
    copia_link_volantino: "Kopie Link Veröffentlichung",
    copia: "Kopieren",
    copia_link_lista: "Link zur Liste kopieren",
    apri: "Öffnen",
    lista: "Liste",
    cerca_uno_store: "Einen Laden finden",
    mostra_tutti: "alle anzeigen",
    cancella_filtri: "filter löschen",
    pag: "seite",
    vai: "Zur Webseite",
    prodotti_correlati: "Ähnliche Produkte",
    punti_vendita: "Verkaufsstellen",
    sfoglia: "Nudelblatt",
    extra1: "Name des Veranstaltungsortes",
    send_ordine: "Bestellung abschicken",
    username: "Nutzername",
    cookie_detail_tech:
      "Notwendige Cookies tragen zur Benutzerfreundlichkeit der Website bei, indem sie grundlegende Funktionen wie die Seitennavigation und den Zugang zu sicheren Bereichen der Website ermöglichen. Ohne diese Cookies kann die Website nicht richtig funktionieren.",
    cookie_detail_stats:
      "Statistische Cookies helfen den Inhabern von Websites zu verstehen, wie Besucher mit den Websites interagieren, indem sie Informationen in anonymer Form sammeln und übermitteln.",
    rifiuta: "Ablehnen",
    accetta_selezionati: "Ausgewählte akzeptieren",
    accetta_tutti: "Alle akzeptieren",
    consenso: "Zustimmung",
    necessari: "erforderlich",
    tecnici: "erforderlich",
    statistiche: "statistik",
    useCookie: "Diese Website verwendet Cookies",
    cookieText:
      "Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, um Funktionen für soziale Medien bereitzustellen und um unseren Datenverkehr zu analysieren. Wir teilen auch Informationen darüber, wie Sie unsere Website nutzen, mit unseren Webanalyse-, Werbe- und Social-Media-Partnern, die diese mit anderen Informationen kombinieren können, die Sie ihnen zur Verfügung gestellt haben oder die sie aus Ihrer Nutzung ihrer Dienste gesammelt haben.",
    errore_invio_mail: "Fehler beim Senden der E-Mail",
    email_successo: "E-Mail erfolgreich gesendet",
    errore_registrazione: "Bei der Registrierung ist ein Fehler aufgetreten",
    token_non_valido: "Ungültiges oder bereits verwendetes Token",
    email_presente: "E-Mail bereits vorhanden",
    svuota_carrello: "Warenkorb leeren",
    cancella_lista: "Liste löschen",
    manuale: "Anleitung",
    scheda: "Karte",
    allegato: "Anhang",
    volantino: "Durchsuchen",
    prodotti: "Produkte",
    catalogo: "Katalog",
    pagine: "Seiten",
    pdf: "PDF",
    schermo_intero: "Vollbild",
    condividi_volantino: "Veröffentlichung teilen",
    prodotto: "Produkt",
    scegli_una_categoria: "Wähle eine Kategorie",
    scegli_una_sottocategoria: "Wähle eine Unterkategorie",
    reset: "Zurücksetzen",
    aggiungi_alla_lista: "zur anfrage hinzufügen",
    aggiungi_alla_lista_crai: "zur anfrage hinzufügen",
    aggiungi_al_carrello: "In den Warenkorb legen",
    aggiungi: "Hinzufügen",
    aggiungi_crai: "zur anfrage hinzufügen",
    mostra_altri_prodotti: "weitere Produkte anzeigen",
    nessun_prodotto_trovato_per_i_parametri_di_ricerca_inseriti:
      "Kein Produkt gefunden für die eingegebenen Suchparameter",
    effettua_ricerca: 
      "Eine Suche durchführen, um die Produkte im Katalog anzuzeigen",
    dettaglio: "Produkteinfo",
    indietro: "Zurück",
    chiudi: "Schließen",
    scegli: "Wählen",
    prodotto_aggiunto: "Produkt hinzugefügt",
    controlla_la_tua_lista_della_spesa: "Überprüfe deine Einkaufsliste",
    lista_della_spesa: "Einkaufsliste",
    la_tua_lista_della_spesa: "Deine Einkaufsliste",
    elimina_dalla_lista: "Aus der Liste entfernen",
    elimina_dal_carrello: "Aus dem Warenkorb entfernen",
    condividi_lista: "Teilen",
    condividi_con: "Teilen mit",
    totale: "Gesamt",
    imponibile: "Nettobetrag",
    iva: "MwSt.",
    iva_inclusa: "inkl. MwSt.",
    svuota: "Leeren",
    inserisci_un_prodotto_non_presente:
      "Füge ein nicht vorhandenes Produkt ein",
    nome_prodotto: "Produktname",
    prezzo_stimato: "Geschätzter Preis",
    cerca_un_prodotto: "Produkt suchen",
    link_copiato_negli_appunti: "Link in die Zwischenablage kopiert",
    curiosita: "Wissenswertes",
    video: "Video",
    ricetta: "Rezept",
    ingredienti: "Zutaten",
    procedimento: "Verfahren",
    indice: "Index",
    menu: "Menü",
    video_tutorial: "Videoanleitung",
    condividi: "Teilen",
    filtra_prodotti: "Reifengrössen filtern",
    filtra: "Filtern",
    mostra: "Zeigen",
    risultati: "Ergebnisse",
    sto_caricando: "Lade",
    secondi: "Sekunden",
    sfoglia_volantino_tra: "Blättern Sie im Veröffentlichung zwischen",
    reset_filtri: "Filter zurücksetzen",
    descrizione: "Beschreibung",
    carosello: "Karussell",
    per_quantita: "pro Menge",
    offerta: "Angebot",
    scopri_il_prezzo: "Preis entdecken",
    scopri: "Entdecken",
    attendi_scopri_prezzo: "Bitte warten Sie einen Moment, um den Preis von",
    caratteristiche: "Eigenschaften",
    il_tuo_carrello: "Ihr Warenkorb",
    stiamo_generando_lista_spesa: "Wir generieren Ihre Einkaufsliste",
    visualizza_lista_spesa: "Zeige Ihre Einkaufsliste",
    elemento_copiato: "Element kopiert",
    errore_nella_copia: "Fehler beim Kopieren",
    link_non_copiato: "Link nicht kopiert",
    torna_al_volantino: "Zurück zum Veröffentlichung",
    salva_come_immagine: "Als Bild speichern",
    sei_sicuro_svuota_carrello:
      "Sind Sie sicher, dass Sie Ihren Warenkorb leeren möchten",
    annulla: "Abbrechen",
    conferma: "Bestätigen",
    vai_prodotti: "Zu den produkten",
    cerca: "Suche",
    effettua_login: "Einloggen",
    accedi_dall_app: "In der App anmelden",
    accedi_dall_app_testo: "Melden Sie sich in der App mit Ihrem Konto an, um den Prospekt zu sehen.",
    crea_account: "Konto erstellen",
    resetta_psw: "Passwort zurücksetzen",
    login: "Anmelden",
    registrati: "Registrieren",
    rec_psw: "Passwort zurücksetzen",
    telephone: "Telefon",
    indirizzo: "Adresse",
    nome: "Vorname",
    cognome: "Nachname",
    benvenuto: "Willkommen",
    aggiungi_non_presente: "Füge ein nicht vorhandenes Produkt hinzu",
    email: "E-Mail",
    no_account: "Sie haben noch kein Konto? Registrieren Sie sich",
    already_account: "Sie haben bereits ein Konto? Melden Sie sich an",
    email_non_presente: "E-Mail nicht vorhanden",
    mostra_piu: "Mehr anzeigen",
    codice_cliente: "Kundennummer",
    password: "Passwort festlegen",
    completa_ordine: "Anfrage abschließen",
    registrazione_success:
      "Registrierung erfolgreich abgeschlossen. Bitte überprüfe deine E-Mail, um Zugriff zu erhalten! Wenn Sie keine E-Mails in Ihrem Posteingang finden, überprüfen Sie Ihr SPAM-Postfach.",
    iva_esclusa: "Ohne MwSt",
    esporta_pdf: "Als PDF exportieren",
    esporta_csv: "Als CSV exportieren",
    parametri_mancanti: " Fehlende Parameter",
    email_pass_non_trovati: " E-Mail und/oder Passwort nicht gefunden",
    lista_gia_inviata: "Bestellung bereits gesendet",
    lista_inviata_messaggio: "Diese Bestellung wurde bereits gesendet. Was möchten Sie tun?",
    lista_inviata_messaggio_whatsapp: "Diese Einkaufsliste wurde bereits über WhatsApp gesendet. Was möchten Sie tun?",
    svuota_lista: "Liste leeren",
    continua: "Weiter",
    benvenuto_lista_gia_inviata: "Willkommen zurück!",
    benvenuto_lista_gia_inviata_messaggio: "Es befinden sich Produkte in der Liste. Möchten Sie sie behalten oder die Liste leeren?",
    tutti: "Alle",
    sottocategorie: "Unterkategorien",
    caricamento: "Laden…",
    hai_visto_tutto: "Sie haben alles gesehen",
    mostra_tutti_reset: "Alle Produkte anzeigen",
    nessun_prodotto_hint: "Versuchen Sie eine andere Kategorie.",
    apri_filtri: "Filter öffnen",
    rimuovi_filtro: "Filter entfernen {label}",
    offerte: "Angebote",
    interattivita_section: "Interaktivitäten",
    link_interno: "Interner Link",
    link_esterno: "Externer Link",
    specifiche: "Spezifikationen",
    categorie: "Kategorien",
    tutti_i_prodotti: "Alle Produkte",
    prodotti_filtrati: "Gefilterte Produkte",
    risultati_per: "Ergebnisse für «{q}»",
    filtri: "Filter",
    nessun_filtro_selezionato: "Kein Filter ausgewählt",
    n_filtri_selezionati: "{n} Filter ausgewählt",
    cancella: "Löschen",
    applica_filtri: "Filter anwenden ({n})",
    nessun_risultato: "Keine Ergebnisse",
    nessun_prodotto_combinazione:
      "Keine Produkte für diese Filterkombination",
    tag_section: "Tag",
    promo_section: "Promo",
    marchi_section: "Marken",
    chiudi_filtri: "Filter schließen",
    nessun_filtro_disponibile: "Keine Filter für diese Veröffentlichung verfügbar.",
    chiudi_ricerca: "Suche schließen",
    cerca_prodotti: "Produkte suchen",
    digita_almeno_2: "Geben Sie mindestens 2 Zeichen ein",
    n_risultati_trovati: "{n} Ergebnisse gefunden",
    n_risultati_primi_30: "{n} Ergebnisse · Top 30",
    nessun_risultato_per: "Keine Ergebnisse für «{q}»",
    prova_altro_termine:
      "Versuchen Sie einen anderen Begriff oder prüfen Sie die Schreibweise",
    pulisci_ricerca: "Suche löschen",
    inizia_a_digitare:
      "Beginnen Sie zu tippen, um ein Produkt in der aktiven Werbung zu suchen",
    categorie_suggerite: "Vorgeschlagene Kategorien",
    vedi_tutti_n_risultati: "Alle {n} Ergebnisse in der Liste anzeigen",
    nessun_risultato_short: "Keine Ergebnisse",
    // Auth & Profile
    password_dimenticata: "Passwort vergessen?",
    invia_link_reset: "Reset-Link senden",
    inserisci_email_reset: "Geben Sie Ihre E-Mail ein, um Ihr Passwort wiederherzustellen",
    email_inviata_reset: "Wir haben Ihnen eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts gesendet",
    torna_al_login: "Zurück zur Anmeldung",
    conferma_password: "Passwort bestätigen",
    accetto_privacy: "Ich akzeptiere die Datenschutzrichtlinie",
    password_non_corrispondono: "Passwörter stimmen nicht überein",
    privacy_obbligatoria: "Sie müssen die Datenschutzrichtlinie akzeptieren",
    password_min_length: "Mindestens 8 Zeichen",
    password_uppercase: "Ein Großbuchstabe",
    password_lowercase: "Ein Kleinbuchstabe",
    password_number: "Eine Zahl",
    password_special_char: "Ein Sonderzeichen",
    profilo: "Profil",
    modifica_profilo: "Profil bearbeiten",
    cambia_password: "Passwort ändern",
    elimina_account: "Konto löschen",
    logout: "Logout",
    conferma_eliminazione: "Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion ist unwiderruflich.",
    nuova_password: "Neues Passwort",
    conferma_nuova_password: "Neues Passwort bestätigen",
    salva_modifiche: "Änderungen speichern",
    vai_al_profilo: "Zum Profil",
    ordini: "Bestellungen",
    preferiti: "Favoriten",
    premi: "Preise",
    assistenza: "Unterstützung",
    password_cambiata_successo: "Passwort erfolgreich geändert",
    profilo_aggiornato_successo: "Profil erfolgreich aktualisiert",
    account_eliminato_successo: "Konto erfolgreich gelöscht",
  },
  es_ES: {
    carrello: "Carro",
    copia_link_lista: "Copiar link de lista",
    copia_link_volantino: "Copiar link de publicación",
    copia: "Copiar",
    apri: "Abra",
    lista: "Lista",
    cerca_uno_store: "Buscar una tienda",
    mostra_tutti: "mostrar todo",
    cancella_filtri: "eliminar filtros",
    pag: "pág",
    vai: "ir",
    punti_vendita: "Puntos de venta",
    prodotti_correlati: "Productos relacionados",
    sfoglia: "Consulte",
    extra1: "Nombre del lugar de celebración",
    send_ordine: "Enviar pedido",
    username: "usuario",
    cookie_detail_tech:
      "Las cookies necesarias contribuyen a la usabilidad del sitio web al permitir funcionalidades básicas como la navegación por las páginas y el acceso a áreas seguras del sitio web. El sitio web no puede funcionar correctamente sin estas cookies.",
    cookie_detail_stats:
      "Las cookies estadísticas ayudan a los propietarios de sitios web a comprender cómo interactúan los visitantes con los sitios mediante la recopilación y transmisión de información de forma anónima.",
    rifiuta: "Rechazar",
    accetta_selezionati: "Aceptar seleccionado",
    accetta_tutti: "Aceptar todo",
    consenso: "Consentimiento",
    necessari: "necesario",
    tecnici: "necesario",
    statistiche: "estadísticas",
    useCookie: "Este sitio web utiliza cookies",
    cookieText:
      "Utilizamos cookies para personalizar el contenido y los anuncios, ofrecer funciones de redes sociales y analizar nuestro tráfico. También compartimos información sobre cómo utiliza nuestro sitio con nuestros socios de análisis web, publicidad y redes sociales, que pueden combinarla con otra información que usted les haya proporcionado o que hayan recopilado a partir del uso que usted hace de sus servicios.",
    errore_invio_mail: "Error al enviar el correo electrónico",
    email_successo: "Correo electrónico enviado con éxito",
    errore_registrazione: "Se ha producido un error durante el registro",
    token_non_valido: "Token inválido o ya utilizado",
    email_presente: "Email ya registrada",
    svuota_carrello: "Vaciar carrito",
    cancella_lista: "Borrar lista",
    manuale: "Instrucciones",
    scheda: "Tarjeta",
    allegato: "Adjunto",
    volantino: "Consulte",
    prodotti: "Productos",
    catalogo: "Catálogo",
    pagine: "Páginas",
    pdf: "PDF",
    schermo_intero: "Pantalla completa",
    condividi_volantino: "Compartir publicación",
    prodotto: "Producto",
    scegli_una_categoria: "Elige una categoría",
    scegli_una_sottocategoria: "Elige una subcategoría",
    reset: "Restablecer",
    aggiungi_alla_lista: "Agregar a la lista",
    aggiungi_alla_lista_crai: "Agregar a la lista",
    aggiungi_al_carrello: "Añadir al carrito",
    aggiungi: "Agregar",
    aggiungi_crai: "Agregar a la lista",
    mostra_altri_prodotti: "Mostrar más productos",
    nessun_prodotto_trovato_per_i_parametri_di_ricerca_inseriti:
      "No se encontraron productos para los parámetros de búsqueda ingresados",
    effettua_ricerca:
      "Realiza una búsqueda para ver los productos del catálogo",
    dettaglio: "Detalle",
    indietro: "Atrás",
    chiudi: "Cerrar",
    scegli: "Elegir",
    prodotto_aggiunto: "Producto agregado",
    controlla_la_tua_lista_della_spesa: "Verifica tu lista de compras",
    lista_della_spesa: "Lista de compras",
    la_tua_lista_della_spesa: "Tu lista de compras",
    elimina_dalla_lista: "Eliminar de la lista",
    elimina_dal_carrello: " Eliminar del carrito",
    condividi_lista: "Compartir",
    condividi_con: "Compartir con",
    totale: "Total",
    imponibile: "Base imponible",
    iva: "IVA",
    iva_inclusa: "IVA incluida",
    svuota: "Vaciar",
    inserisci_un_prodotto_non_presente: "Ingresa un producto no presente",
    nome_prodotto: "Nombre del producto",
    prezzo_stimato: "Precio estimado",
    cerca_un_prodotto: "Buscar un producto",
    link_copiato_negli_appunti: "Enlace copiado al portapapeles",
    curiosita: "Curiosidad",
    video: "Video",
    ricetta: "Receta",
    ingredienti: "Ingredientes",
    procedimento: "Procedimiento",
    indice: "Índice",
    menu: "Menú",
    video_tutorial: "Tutorial en video",
    condividi: "Compartir",
    filtra_prodotti: "Filtrar productos",
    filtra: "Filtrar",
    mostra: "Mostrar",
    risultati: "resultados",
    sto_caricando: "Cargando",
    secondi: "segundos",
    sfoglia_volantino_tra: "Navega por la publicación entre",
    reset_filtri: "Restablecer filtros",
    descrizione: "Descripción",
    carosello: "Carrusel",
    per_quantita: "por cantidad",
    offerta: "Oferta",
    scopri_il_prezzo: "Descubre el precio",
    scopri: "Descubrir",
    attendi_scopri_prezzo: "Espera un momento para ver el precio de",
    caratteristiche: "Características",
    il_tuo_carrello: "Tu carrito",
    stiamo_generando_lista_spesa: "Estamos generando tu lista de compras",
    visualizza_lista_spesa: "Ver lista de compras",
    elemento_copiato: "Elemento copiado",
    errore_nella_copia: "Error al copiar",
    link_non_copiato: "Enlace no copiado",
    torna_al_volantino: "Volver a la publicación",
    salva_come_immagine: "Guardar como imagen",
    sei_sicuro_svuota_carrello:
      "¿Estás seguro de que quieres vaciar tu carrito",
    annulla: "Cancelar",
    conferma: "Confirmar",
    vai_prodotti: "Ir a productos",
    cerca: "Buscar",
    effettua_login: "Inicia sesión",
    accedi_dall_app: "Inicia sesión desde la app",
    accedi_dall_app_testo: "Inicia sesión con tu cuenta en la app para ver el folleto.",
    crea_account: "Crear cuenta",
    resetta_psw: "Restablecer contraseña",
    login: "Iniciar sesión",
    registrati: "Registrarse",
    rec_psw: "Recuperar",
    telephone: "Teléfono",
    indirizzo: "Dirección",
    nome: "Nombre",
    cognome: "Apellido",
    benvenuto: "Bienvenido",
    aggiungi_non_presente: "Agregar un producto no presente",
    email: "Correo electrónico",
    no_account: "¿No tienes una cuenta? Regístrate",
    already_account: "¿Ya tienes una cuenta? Iniciar sesión",
    email_non_presente: "Correo electrónico no presente",
    mostra_piu: "Mostrar más",
    codice_cliente: "Código de cliente",
    password: "contraseña",
    completa_ordine: "Completa pedido",
    registrazione_success:
      "¡Registro completado exitosamente! ¡Verifica tu correo electrónico para acceder! Si no encuentra ningún correo electrónico en su bandeja de entrada, marque su casilla de SPAM.",
    iva_esclusa: "IVA excluida",
    esporta_pdf: "Exportar a PDF",
    esporta_csv: "Exportar a CSV",
    parametri_mancanti: "Parámetros faltantes",
    email_pass_non_trovati: "Email y/o contraseña no encontrados",
    lista_gia_inviata: "Pedido ya enviado",
    lista_inviata_messaggio: "Este pedido ya fue enviado. ¿Qué deseas hacer?",
    lista_inviata_messaggio_whatsapp: "Esta lista de compras ya fue enviada por WhatsApp. ¿Qué deseas hacer?",
    svuota_lista: "Vaciar lista",
    continua: "Continuar",
    benvenuto_lista_gia_inviata: "¡Bienvenido de nuevo!",
    benvenuto_lista_gia_inviata_messaggio: "Hay productos en la lista. ¿Quieres mantenerlos o vaciar la lista?",
    tutti: "Todos",
    sottocategorie: "Subcategorías",
    caricamento: "Cargando…",
    hai_visto_tutto: "Lo has visto todo",
    mostra_tutti_reset: "Mostrar todos los productos",
    nessun_prodotto_hint: "Prueba con otra categoría.",
    apri_filtri: "Abrir filtros",
    rimuovi_filtro: "Quitar filtro {label}",
    offerte: "Ofertas",
    interattivita_section: "Interactividades",
    link_interno: "Enlace interno",
    link_esterno: "Enlace externo",
    specifiche: "Especificaciones",
    categorie: "Categorías",
    tutti_i_prodotti: "Todos los productos",
    prodotti_filtrati: "Productos filtrados",
    risultati_per: "Resultados para «{q}»",
    filtri: "Filtros",
    nessun_filtro_selezionato: "Ningún filtro seleccionado",
    n_filtri_selezionati: "{n} filtros seleccionados",
    cancella: "Borrar",
    applica_filtri: "Aplicar filtros ({n})",
    nessun_risultato: "Sin resultados",
    nessun_prodotto_combinazione:
      "Ningún producto coincide con esta combinación de filtros",
    tag_section: "Tag",
    promo_section: "Promo",
    marchi_section: "Marcas",
    chiudi_filtri: "Cerrar filtros",
    nessun_filtro_disponibile: "No hay filtros disponibles para esta publicación.",
    chiudi_ricerca: "Cerrar búsqueda",
    cerca_prodotti: "Buscar productos",
    digita_almeno_2: "Escribe al menos 2 caracteres",
    n_risultati_trovati: "{n} resultados encontrados",
    n_risultati_primi_30: "{n} resultados · primeros 30",
    nessun_risultato_per: "Sin resultados para «{q}»",
    prova_altro_termine: "Prueba con otro término o revisa la ortografía",
    pulisci_ricerca: "Limpiar búsqueda",
    inizia_a_digitare:
      "Empieza a escribir para buscar un producto del folleto activo",
    categorie_suggerite: "Categorías sugeridas",
    vedi_tutti_n_risultati: "Ver todos los {n} resultados en la lista",
    nessun_risultato_short: "Sin resultados",
    // Auth & Profile
    password_dimenticata: "¿Olvidaste tu contraseña?",
    invia_link_reset: "Enviar enlace de restablecimiento",
    inserisci_email_reset: "Ingresa tu email para recuperar tu contraseña",
    email_inviata_reset: "Te hemos enviado un email con un enlace para restablecer tu contraseña",
    torna_al_login: "Volver al inicio de sesión",
    conferma_password: "Confirmar contraseña",
    accetto_privacy: "Acepto la política de privacidad",
    password_non_corrispondono: "Las contraseñas no coinciden",
    privacy_obbligatoria: "Debes aceptar la política de privacidad",
    password_min_length: "Al menos 8 caracteres",
    password_uppercase: "Una letra mayúscula",
    password_lowercase: "Una letra minúscula",
    password_number: "Un número",
    password_special_char: "Un carácter especial",
    profilo: "Perfil",
    modifica_profilo: "Editar perfil",
    cambia_password: "Cambiar contraseña",
    elimina_account: "Eliminar cuenta",
    logout: "Logout",
    conferma_eliminazione: "¿Estás seguro de que deseas eliminar tu cuenta? Esta acción es irreversible.",
    nuova_password: "Nueva contraseña",
    conferma_nuova_password: "Confirmar nueva contraseña",
    salva_modifiche: "Guardar cambios",
    vai_al_profilo: "Ir al perfil",
    ordini: "Pedidos",
    preferiti: "Favoritos",
    premi: "Premios",
    assistenza: "Soporte",
    password_cambiata_successo: "Contraseña cambiada con éxito",
    profilo_aggiornato_successo: "Perfil actualizado con éxito",
    account_eliminato_successo: "Cuenta eliminada con éxito",
  },
};
